/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ContactType } from './ContactType';
import {
    ContactTypeFromJSON,
    ContactTypeFromJSONTyped,
    ContactTypeToJSON,
} from './ContactType';
import type { ServiceTeamMemberProfile } from './ServiceTeamMemberProfile';
import {
    ServiceTeamMemberProfileFromJSON,
    ServiceTeamMemberProfileFromJSONTyped,
    ServiceTeamMemberProfileToJSON,
} from './ServiceTeamMemberProfile';

/**
 * A member of a service team
 * @export
 * @interface ServiceTeamMemberWithDetails
 */
export interface ServiceTeamMemberWithDetails {
    /**
     * A URI value that typically starts with the "sharefile" schema.  Segments are delimited with a "/". Segments are composed of a leaf  type and identifier that is delimited by "-".
     * 
     * @type {string}
     * @memberof ServiceTeamMemberWithDetails
     */
    rID: string;
    /**
     * 
     * @type {Date}
     * @memberof ServiceTeamMemberWithDetails
     */
    createdAtUtc: Date;
    /**
     * A URI value that typically starts with the "sharefile" schema.  Segments are delimited with a "/". Segments are composed of a leaf  type and identifier that is delimited by "-".
     * 
     * @type {string}
     * @memberof ServiceTeamMemberWithDetails
     */
    createdByUserRID: string;
    /**
     * 
     * @type {Date}
     * @memberof ServiceTeamMemberWithDetails
     */
    lastUpdatedAtUtc?: Date | null;
    /**
     * A URI value that typically starts with the "sharefile" schema.  Segments are delimited with a "/". Segments are composed of a leaf  type and identifier that is delimited by "-".
     * 
     * @type {string}
     * @memberof ServiceTeamMemberWithDetails
     */
    lastUpdatedByUserRID?: string;
    /**
     * 
     * @type {ContactType}
     * @memberof ServiceTeamMemberWithDetails
     */
    contactType: ContactType;
    /**
     * 
     * @type {ServiceTeamMemberProfile}
     * @memberof ServiceTeamMemberWithDetails
     */
    details?: ServiceTeamMemberProfile;
}

/**
 * Check if a given object implements the ServiceTeamMemberWithDetails interface.
 */
export function instanceOfServiceTeamMemberWithDetails(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "rID" in value;
    isInstance = isInstance && "createdAtUtc" in value;
    isInstance = isInstance && "createdByUserRID" in value;
    isInstance = isInstance && "contactType" in value;

    return isInstance;
}

export function ServiceTeamMemberWithDetailsFromJSON(json: any): ServiceTeamMemberWithDetails {
    return ServiceTeamMemberWithDetailsFromJSONTyped(json, false);
}

export function ServiceTeamMemberWithDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceTeamMemberWithDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'rID': json['RID'],
        'createdAtUtc': (new Date(json['createdAtUtc'])),
        'createdByUserRID': json['createdByUserRID'],
        'lastUpdatedAtUtc': !exists(json, 'lastUpdatedAtUtc') ? undefined : (json['lastUpdatedAtUtc'] === null ? null : new Date(json['lastUpdatedAtUtc'])),
        'lastUpdatedByUserRID': !exists(json, 'lastUpdatedByUserRID') ? undefined : json['lastUpdatedByUserRID'],
        'contactType': ContactTypeFromJSON(json['contactType']),
        'details': !exists(json, 'details') ? undefined : ServiceTeamMemberProfileFromJSON(json['details']),
    };
}

export function ServiceTeamMemberWithDetailsToJSON(value?: ServiceTeamMemberWithDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'RID': value.rID,
        'createdAtUtc': (value.createdAtUtc.toISOString()),
        'createdByUserRID': value.createdByUserRID,
        'lastUpdatedAtUtc': value.lastUpdatedAtUtc === undefined ? undefined : (value.lastUpdatedAtUtc === null ? null : value.lastUpdatedAtUtc.toISOString()),
        'lastUpdatedByUserRID': value.lastUpdatedByUserRID,
        'contactType': ContactTypeToJSON(value.contactType),
        'details': ServiceTeamMemberProfileToJSON(value.details),
    };
}

